import axios from 'axios';
import { getSharedFileByIdQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';

const getSharedFileById = async (fileId) => {
    const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
    const queryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
    const query = getSharedFileByIdQuery({ fileId, queryBuilder });
    const resp = await axios.get(query);
    return resp.data;
};

export default getSharedFileById;
